import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const createUser = graphql(
  gql`
    mutation SignUp(
      $user: UserInput!,
      $device: String,
      $captchaToken: String,
      $source: String,
      $byManager: String,
      $affiliate: String,
      $accountManager: String,
      $salesRepAssign: String,
      $utmSource: String
    ) {
      signUp(
        user: $user,
        device: $device,
        captchaToken: $captchaToken,
        source: $source,
        byManager: $byManager,
        affiliate: $affiliate,
        accountManager: $accountManager
        salesRepAssign: $salesRepAssign
        utmSource: $utmSource
      ) {
        user {
          id
          shortId: short_id
          email
          administrator
          name: first_name
          lastName: last_name
          triggerWelcome: trigger_welcome
        }
        token
      }
    }
  `,
  {
    name: 'signUpUser'
  }
)

export const countriesQuery = gql`
  query getCountries {
    countries: getCountries {
      name: countryName
      code: countryCode
      geonameId
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SignUp/data.ts